var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4287 21.4836V78.5161C26.4287 80.1245 27.7326 81.4284 29.341 81.4284H71.3735C72.982 81.4284 74.2858 80.1245 74.2858 78.5161L74.2859 32.1253L62.3216 18.5713H29.341C27.7326 18.5713 26.4287 19.8752 26.4287 21.4836Z",
    fill: "#E283B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3228 29.2304V18.5713L74.2819 32.1427H65.2351C63.6266 32.1427 62.3228 30.8388 62.3228 29.2304Z",
    fill: "#F0C1D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4282 41.0482C16.4282 38.8917 18.1764 37.1436 20.3329 37.1436H33.9779C35.1606 37.1436 36.2795 37.6796 37.0207 38.6012L40.7035 43.1804H80.4943C82.6508 43.1804 84.399 44.9286 84.399 47.0851V81.5339C84.399 83.6904 82.6508 85.4386 80.4943 85.4386H20.3329C18.1764 85.4386 16.4282 83.6904 16.4282 81.5339V41.0482Z",
    fill: "#F0C1D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7987 55.1982C48.7264 55.1982 47.8571 56.0675 47.8571 57.1398V62.9802L41.9415 62.9802C40.8693 62.9802 40 63.8495 40 64.9218V66.2268C40 67.2991 40.8693 68.1684 41.9415 68.1684H47.8571V74.0094C47.8571 75.0817 48.7264 75.9509 49.7987 75.9509H51.1038C52.1761 75.9509 53.0453 75.0817 53.0453 74.0094V68.1684H58.8112C59.8834 68.1684 60.7527 67.2991 60.7527 66.2268V64.9218C60.7527 63.8495 59.8834 62.9802 58.8112 62.9802L53.0453 62.9802V57.1398C53.0453 56.0675 52.1761 55.1982 51.1038 55.1982H49.7987Z",
    fill: "#002E52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.5ed9181ad1ce80335099b9b33a0e86a6.svg";
export { ForwardRef as ReactComponent };